"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnalyticsService {
    constructor() {
        this.analyticsLoaded = false;
        this.loadAnalyticsScript = () => {
            const snippetOptimize = document.createElement('script');
            snippetOptimize.async = true;
            snippetOptimize.defer = true;
            snippetOptimize.innerHTML = `
        (function (a, s, y, n, c, h, i, d, e) {
          s.className += ' ' + y; h.start = 1 * new Date;
              h.end = i = function () { s.className = s.className.replace(RegExp(' ?' + y), '') };
              (a[n] = a[n] || []).hide = h; setTimeout(function () { i(); h.end = null }, c); h.timeout = c;
          })(window, document.documentElement, 'async-hide', 'dataLayer', 4000,
              { 'GTM-PTX3XVW': true });
    `;
            document.head.appendChild(snippetOptimize);
            (function (i, s, o, g, r, a, m) {
                const date = new Date();
                i['GoogleAnalyticsObject'] = r;
                (i[r] =
                    i[r] ||
                        function () {
                            ;
                            (i[r].q = i[r].q || []).push(arguments);
                        }),
                    (i[r].l = 1 * date);
                (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
                a.async = 0;
                a.src = g;
                m.parentNode.insertBefore(a, m);
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
            this.analyticsLoaded = true;
        };
        this.loadTagManagerScript = (gtmTrackingId) => {
            ;
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js',
                });
                var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = false;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', gtmTrackingId);
            (function (d) {
                const noScript = document.createElement('noscript');
                const iframe = document.createElement('iframe');
                iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + gtmTrackingId;
                iframe.height = '0';
                iframe.width = '0';
                iframe.style.display = 'none';
                iframe.style.visibility = 'hidden';
                noScript.appendChild(iframe);
                d.body.appendChild(noScript);
            })(document);
        };
        this.initialize = (gtmTrackingId) => {
            if (this.analyticsLoaded) {
                return;
            }
            this.loadAnalyticsScript();
            this.loadTagManagerScript(gtmTrackingId);
        };
        this.isOnline = () => {
            return navigator.onLine;
        };
        this.networkStatus = () => {
            return this.isOnline() ? 'online' : 'offline';
        };
        this.sendEvent = (dataLayer) => {
            if (!this.isOnline()) {
                return;
            }
            window.dataLayer.push(dataLayer);
        };
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new AnalyticsService();
        }
        return this.instance;
    }
}
exports.default = AnalyticsService;
